import { useEffect } from "react";
import { useRequiredContext } from "contexts/utils";
import { UserContext } from "contexts/UserContext";
import type { SignInLocationState } from "pages/SignIn/SignIn";
import { useLocationState } from "utils/routing";

export default function SignOut() {
  const { signOut } = useRequiredContext(UserContext);
  const signInState = useLocationState<SignInLocationState>();

  useEffect(() => {
    void signOut(signInState);
  }, [signOut, signInState]);

  return null;
}
